import React, { useEffect, useRef, useState } from "react";
import { Outlet, useLocation, useRoutes } from "react-router-dom";
import Adminsidebar from "../Components/sidebar/adminsidebar";
import logo from "./../assets/images/logo.svg";
import logouticon from "./../assets/images/logout-icon.svg";
import { useNavigate, useSearchParams } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import UserProfilelogo from "./../assets/images/userProfile.svg";
import NotificationIcon from "./../assets/images/notification_icon.svg";
import MenuhorizontalIcon from "./../assets/images/menu_horizontal_icon.svg";
import SearchIcon from "./../assets/images/lucide_search.svg";
import LightIcon from "./../assets/images/light_icon.svg";
import DarkIcon from "./../assets/images/dark_icon.svg";
import Pricingdatabase from "./Pages/Pricingdatabase";
import { Grade } from "./Pages/grade";
import Offeredproduct from "./Pages/offeredproduct";
import { OfferMapping } from "./Pages/Offer-Mapping";
import Pricingmodel from "./Pages/pricingmodel";
import Productvalue from "./Pages/productvalue";
import Sandbox from "./Pages/sandbox";
import Ruledatabase from "./Pages/Ruledatabase";
import { TermsMapping } from "./Pages/Terms-Mapping";
import Tenor from "./Pages/tenor";
import Deconfig from "./Pages/deconfig";
import MapProvider from "./Components/MapProvider";
import { useStateValue } from "../Context/StateProvider";
import Guard from "../Components/Guard/Guard";
import { Unauthorized } from "./Pages/Unauthorized";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import ToggleExpandIcon from "./../assets/images/toggleExpand_icon.svg";
import FullScreenIcon from "./../assets/images/fullscreen_icon.svg";
import FullScreenExitIcon from "./../assets/images/fullscreenExit_icon.svg";
import LogoutIcon from "./../assets/images/humbleicons_logout.svg";
import Brandlogo from "./../assets/images/brand_logo.svg";

import UsIcon from "./../assets/images/us.svg";
import AEIcon from "./../assets/images/ae.svg";
import SpainIcon from "./../assets/images/spain.svg";
import BreadCrumb from "./Breadcrumb/breadcrumb";

const Admin = () => {
  // Expand and Responsive
  const [toggleIcon, setToggleIcon] = useState(false);
  const tabContentRef = useRef(null);
  const queryParams = useLocation();
  const navigate = useNavigate();
  const [show, setShow] = useState(false);

  // const [queryParameters] = useSearchParams();
  // console.log("Query Params:::", queryParameters);
  // const admin_id = queryParameters.get("tid");
  // const urlToken = queryParameters.get("t");
  const [{}, dispatch] = useStateValue();
  // const [settingData, setSetting] = useState([]);

  const handleClose = () => {
    setShow(false);
  };
  const handleOpen = () => {
    setShow(true);
  };

  const logout = async () => {
    navigate("/admin/login");
    sessionStorage.clear();
  };

  const routes = useRoutes([
    // { path: "/unauthorized", element: <Unauthorized /> },
    {
      element: <Guard />,
      children: [
        { path: "/pricingdatabase", element: <Pricingdatabase /> },
        { path: "/offeredproduct", element: <Offeredproduct /> },
        { path: "/pricingmodel", element: <Pricingmodel /> },
        { path: "/productvalue", element: <Productvalue /> },
        { path: "/sandbox", element: <Sandbox /> },
        { path: "/termmodel", element: <Tenor /> },
        { path: "/termsmapping", element: <TermsMapping /> },
        { path: "/deconfig", element: <Deconfig /> },
        { path: "/ruledatabase", element: <Ruledatabase /> },
        { path: "/offersmaping", element: <OfferMapping /> },
        { path: "/grade", element: <Grade /> },
        // { path: "/", element: <Ruledatabase /> }
      ],
    },
  ]);
  const logoutUser = (e) => {
    sessionStorage.clear();
    window.close();
  };

  // useEffect(() => {
  //   // setSetting('hjkk')
  //   console.log("Inside Use Effect");
  //   if(admin_id !== null && urlToken !== null) {
  //     const primaryToken = urlToken.split("-")[1];
  //     const reqBody = {
  //       url: "api/auth/login",
  //       data: {
  //         admin_id,
  //         token: primaryToken,
  //       },
  //     };
  //     Post(reqBody.url, reqBody.data)
  //       .then((res) => {
  //         console.log("Login Res:::", res);
  //         if (res.status === 200) {
  //           sessionStorage.setItem("token", res.jwtAccessToken);
  //           sessionStorage.setItem("admin_id", admin_id);
  //           console.log("Token Set");
  //           navigate("/ruledatabase");
  //         }
  //       })
  //       .catch((err) => {
  //         console.log(err)
  //       });
  //   }
  // }, []);
  useEffect(() => {
    if (routes === null) {
      navigate("/unauthorized");
    }
    window.scrollTo(0, 0);
  }, [queryParams.pathname]);
  return (
    <div className="bluebackground">
      <div
        className={
          queryParams.pathname !== "/admin/login" && toggleIcon
            ? "page_wrapper show"
            : "page_wrapper"
        }
      >
        <div className="mobile_nav">
          <div className="mobile_header ">
            <div className="brandlogo">
              <img src={Brandlogo} alt="brandlogo" />
            </div>
            <div>
              <button
                className="emptyButton"
                onClick={() => setToggleIcon((prev) => !prev)}
              >
                <img
                  src={ToggleExpandIcon}
                  className="mobileMenuicon blackFilter"
                  alt="menuicon"
                />
              </button>
            </div>
          </div>
          <div className="header_show">
            {/* <ul class="header_showlist">
               <li>
                <button className="emptyButton">
                  <img src={FullScreenIcon} alt="FullScreenIcon" />
                  <img src={FullScreenExitIcon} alt="FullScreenExitIcon" />
                </button>
              </li>

            </ul> */}
            <div>
              <ul class="header_showlist">
                <li>
                  <Dropdown className="contrySelect">
                    <Dropdown.Toggle id="dropdown-basic">
                      <img src={UsIcon} alt="UsIcon" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item>
                        <img src={UsIcon} alt="UsIcon" />
                        <span>Us</span>
                      </Dropdown.Item>
                      {/* <Dropdown.Item>
                        <img src={AEIcon} alt="AEIcon" />
                        <span>Arabic</span>
                      </Dropdown.Item>

                      <Dropdown.Item>
                        <img src={SpainIcon} alt="SpainIcon" />
                        <span>Española</span>
                      </Dropdown.Item> */}
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
                <li>
                  <button className="emptyButton" disabled>
                    <img src={FullScreenIcon} alt="FullScreenIcon" />

                    {/* <img
                      src={isFullscreen ? FullScreenExitIcon : FullScreenIcon}
                      alt={isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
                    /> */}
                  </button>
                </li>
                <li>
                  <button className="emptyButton" disabled>
                    <img src={DarkIcon} alt="DarkIcon" />
                    {/* <img src={LightIcon} alt="LightIcon" /> */}
                  </button>
                </li>

                <li>
                  <button className="emptyButton" onClick={handleOpen}>
                    <img src={LogoutIcon} alt="LogoutIcon" />
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {queryParams.pathname !== "/admin/login" && (
          <>
            <Adminsidebar
              setToggleIcon={setToggleIcon}
              toggleIcon={toggleIcon}
            />
          </>
        )}
        <div
          className={
            queryParams.pathname !== "/admin/login" && "content_wrapper"
          }
        >
          <div className="headerArea">
            <div className="displayFlex AlignItemCenter gap12">
              <div>
                <button
                  className="emptyButton"
                  onClick={() => setToggleIcon((prev) => !prev)}
                >
                  <img src={ToggleExpandIcon} alt="ToggleExpandIcon" />
                </button>
              </div>
              <div>
                <div class="inputMate">
                  <input type="search" placeholder="Search ..." />

                  <div class="inputMateAppend">
                    <span class="inputMateText">
                      <img src={SearchIcon} alt="SearchIcon" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <ul class="user_admin">
                <li>
                  <Dropdown className="contrySelect">
                    <Dropdown.Toggle id="dropdown-basic">
                      <img src={UsIcon} alt="UsIcon" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item>
                        <img src={UsIcon} alt="UsIcon" />
                        <span>Us</span>
                      </Dropdown.Item>
                      {/* <Dropdown.Item>
                        <img src={AEIcon} alt="AEIcon" />
                        <span>Arabic</span>
                      </Dropdown.Item>

                      <Dropdown.Item>
                        <img src={SpainIcon} alt="SpainIcon" />
                        <span>Española</span>
                      </Dropdown.Item> */}
                    </Dropdown.Menu>
                  </Dropdown>
                </li>
                <li>
                  <button className="emptyButton iconframe" disabled>
                    <img src={FullScreenIcon} alt="FullScreenIcon" />

                    {/* <img
                      src={isFullscreen ? FullScreenExitIcon : FullScreenIcon}
                      alt={isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
                    /> */}
                  </button>
                </li>
                <li>
                  <button className="emptyButton iconframe" disabled>
                    <img src={DarkIcon} alt="DarkIcon" />
                    {/* <img src={LightIcon} alt="LightIcon" /> */}
                  </button>
                </li>

                <li>
                  <button
                    className="emptyButton iconframe"
                    onClick={handleOpen}
                  >
                    <img src={LogoutIcon} alt="LogoutIcon" />
                  </button>
                </li>
              </ul>
            </div>
          </div>

          <main>
            <div className="mb_24">
              <h1 className="fontWeight500 fs20px blackClrtext ">
                {queryParams.pathname === "/pricingdatabase"
                  ? "Pricing Model Mapping"
                  : queryParams.pathname === "/offeredproduct"
                  ? "Offered Product"
                  : queryParams.pathname === "/productvalue"
                  ? "Product Value"
                  : queryParams.pathname === "/sandbox"
                  ? "Run in Sandbox"
                  : queryParams.pathname === "/termmodel"
                  ? "Term Model"
                  : queryParams.pathname === "/termsmapping"
                  ? "Terms Mapping"
                  : queryParams.pathname === "/deconfig"
                  ? "DE Config"
                  : queryParams.pathname === "/ruledatabase"
                  ? "Rule Database"
                  : queryParams.pathname === "/offersmaping"
                  ? "Offers Mapping"
                  : queryParams.pathname === "/grade"
                  ? "Grade"
                  : queryParams.pathname === "/pricingmodel"
                  ? "Pricing Model"
                  : queryParams.pathname === "/"
                  ? "Rule Database"
                  : null}
              </h1>

              <ul className="custom_breadcrumb">
                <BreadCrumb />
              </ul>
            </div>
            <MapProvider />
            <div>{routes}</div>
          </main>
        </div>
      </div>
      <Modal
        show={show}
        onHide={() => {
          handleClose();
          // formik.resetForm();
        }}
        centered
      >
        <Modal.Header>
          {/* <Modal.Title>Logout Decision Engine</Modal.Title> */}
          <div className="logoutDiv">
            <h4 className="fontWeight500 fs18px blackClrtext">
              Are you sure you want to logout of decision engine?
            </h4>
            <h6>Unsaved changes will be lost</h6>
          </div>
        </Modal.Header>
        {/* <Modal.Body> */}

        <Modal.Footer>
          <button
            className="MainButton aareRiverBrienzClrHvr"
            onClick={() => {
              handleClose();
              // formik.resetForm();
            }}
          >
            No
          </button>
          <button
            type="button"
            onClick={logoutUser}
            className="MainButton aareRiverBrienz_Clr"
          >
            Yes
          </button>
        </Modal.Footer>
        {/* </Modal.Body> */}
      </Modal>
    </div>
  );
};

export default Admin;
